<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('employeeProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('employeeProfile.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{
            $t('add_new')
            }}
          </ts-button>
          <div class="d-flex ts-items-center ts-space-x-3">
            <ts-input
              v-tooltip="$t('employeeProfile.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
			<div class="overflow-auto">
				<ts-table 
					:columns="columns" 
					:records="resources" 
					:loading="loading"
				>
					<template v-slot="{ record }">
						<td>{{ record.branch.branch_name_en }}</td>
						<td class="text-center">
							<img
								class="height-30 ts-rounded"
								v-lazy="{
										src: photoEmp(record),
										error: onError(record),
										loading: require('@/assets/Rolling-1s-200px_2.svg'),
									}"
							/>
						</td>
						<td class="ts-whitespace-no-wrap ts-text-center" >{{ record.card_id }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.employee_name_kh }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.employee_name_en }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.sex }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.date_of_birth }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.phone }}</td>
						<td class="ts-whitespace-no-wrap" >{{ record.position ? record.position.position_name_en : null }}</td>
						<td class="ts-whitespace-no-wrap ts-text-center" >{{ record.status.status }}</td>
						<td class="text-center ts-space-x-3">
							<a href="#" v-tooltip="$t('edit')" class="text-primary" @click.prevent="edit(record)">
								<i class="fas fa-edit"></i>
							</a>
							<a-popconfirm
								placement="leftTop"
								:title="$t('are_you_sure_to_delete')"
								:ok-text="$t('yes')"
								:cancel-text="$t('no')"
								@confirm="deleteRecord(record)"
							>
								<a href="#" :disabled="record._deleting">
									<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
									<i class="fa fa-trash text-red" v-else></i>
								</a>
							</a-popconfirm>
						</td>
					</template>
				</ts-table>
			</div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'profileIndex',
  data() {
    return {
      loading: false,
      showForm: false,
      manPhoto: require('../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../assets/staff-default-women.png')
    }
  },
  computed: {
    ...mapState('employee/profile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.employee.profile.search
      },
      set(newValue) {
        this.$store.commit('employee/profile/SET_SEARCH', newValue)
        this.$store.commit('employee/profile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name:  this.$t('employeeProfile.branch'), style: 'width: 11%' },
        { name:  this.$t('employeeProfile.photo'), style: 'text-align:center; width: 3%' },
        { name:  this.$t('employeeProfile.idCard'), style: 'text-align:center; width: 8%' },
        { name:  this.$t('employeeProfile.nameKh'), style: 'width: 15%' },
        { name:  this.$t('employeeProfile.nameEn'), style: 'width: 15%' },
        { name:  this.$t('employeeProfile.gender'), style: 'text-align:center; width: 3%' },
        { name:  this.$t('employeeProfile.dateOfBirth'), style: 'text-align:center; width: 5%' },
        { name:  this.$t('employeeProfile.phone'), style: 'width: 10%' },
        { name:  this.$t('employeeProfile.position'), style: 'width: 6%'  },
        { name:  this.$t('employeeProfile.status'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width:80px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('employee/profile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
			this.$router.push({ name: 'em-profile-create'})
		},
    edit(record) {
			this.$store.commit('employee/profile/SET_EDIT_DATA', record)
			this.$router.push({ name: 'em-profile-edit', params:{ id: record.employee_id }})
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('employee/profile/destroy', record.employee_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    photoEmp(record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 1 ? this.manPhoto : this.womenPhoto
    },
    onError(record) {
      event
        ? (event.target.src =
            record.gender == 1 ? this.manPhoto : this.womenPhoto)
        : ''
    },
    branchFilter(value){
      this.$store.commit('employee/profile/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('employee/profile/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
